var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 148952",
    width: 24,
    height: 24,
    transform: "translate(156 460)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156 -460)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "folder",
    transform: "translate(157.197 463.123)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10259",
    d: "M22.188,161.787a1.807,1.807,0,0,0-1.552-.846H6.307a1.811,1.811,0,0,0-1.646,1.02L.87,169.908A1.364,1.364,0,0,0,2.2,170.924H17.449a1.72,1.72,0,0,0,1.539-.952l3.276-6.566a1.657,1.657,0,0,0-.076-1.62Zm0,0",
    transform: "translate(-0.834 -153.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10260",
    d: "M3.055,7.068A1.811,1.811,0,0,1,4.7,6.048H18.195V4.322a1.316,1.316,0,0,0-1.338-1.29H8.989a.042.042,0,0,1-.022-.005L7.558,1.058A1.352,1.352,0,0,0,6.457.5H1.338A1.316,1.316,0,0,0,0,1.79V13.474Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFilled);
export default __webpack_public_path__ + "static/media/folder-filled.83a3b57e.svg";
export { ForwardRef as ReactComponent };